import { useRef, useState } from 'react';
import { useQueryParams } from 'use-query-params';
import { useDebouncedCallback } from 'use-debounce';

import { dashboardQueryTypes } from 'utils/query';
import { Svg } from 'components/Svg';
import { Region } from './Region';
import { Columns } from './Columns';

import s from './s.module.css';

export function Filters({ columns, onChangeColumns }) {
  const [query, setQuery] = useQueryParams(dashboardQueryTypes);
  const [searchOpen, setSearchOpen] = useState(!!query.search);
  const searchRef = useRef(null);

  const deb = useDebouncedCallback((value) => {
    setQuery({
      offset: undefined,
      limit: undefined,
      sortBy: undefined,
      order: undefined,
      search: value,
      region: undefined,
    });
  }, 400);

  const closeSearchHandler = () => {
    setQuery({ search: undefined });
    setSearchOpen(false);
  };

  const handlerChangeColumns = (newColumns) => {
    onChangeColumns(newColumns);
  };

  return (
    <div className={s.wrap}>
      <div className={s.content}>
        <Region tabIndex={searchOpen ? -1 : 0} />
        <button
          type="button"
          onClick={() => setSearchOpen(true)}
          className={s.button}
          tabIndex={searchOpen ? -1 : 0}
        >
          <Svg id="magnifying-glass" />
        </button>
        <Columns
          options={columns}
          onChange={handlerChangeColumns}
          buttonClassName={s.button}
          tabIndex={searchOpen ? -1 : 0}
        />
        {searchOpen && (
          <div className={s.searchWrap}>
            <div className={s.searchIcon}>
              <Svg id="magnifying-glass" />
            </div>
            <input
              ref={searchRef}
              className={s.searchInput}
              type="search"
              autoComplete="off"
              placeholder="Enter the miner ID or nickname"
              tabIndex={searchOpen ? 0 : -1}
              autoFocus={searchOpen}
              name="search"
              defaultValue={query.search}
              onChange={(e) => deb(e.target.value)}
            />
            <button
              type="button"
              onClick={closeSearchHandler}
              className={s.closeButton}
              aria-label="Clear search"
            >
              <Svg id="close" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
